import { useAuth0 } from '@auth0/auth0-react';
import { CircularProgress } from "@material-ui/core";
import Switch from '@material-ui/core/Switch';
import {
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import UserService from "Lib/API/users/index";
import React, { useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { NotificationSettingsCloseBtn, NotificationSettingsContent, NotificationSettingsContentItem, NotificationSettingsContentItemBox, NotificationSettingsContentItemName, NotificationSettingsContentItemWrapper, NotificationSettingsHead, NotificationSettingsHeader, NotificationSettingsHeadLabel, NotificationSettingsSwitch, NotificationSettingsSwitchLabel, NotificationSettingsTitle } from "./Theme";
import { fontConfig } from "theme/fontConfig";


const NotificationSettings = ({onClose}) => {
  const { getAccessTokenSilently } = useAuth0();
  const savedNotificationSound = localStorage.getItem("notificationSound") ? JSON.parse(localStorage.getItem("notificationSound")) : true;

  
  const [getNotificationSettingsLoading, setGetNotificationSettingsLoading] = useState(true);
  const [notificationSettings, setNotificationSettings] = useState([]);
  const [selectedNotification, setSelectedNotification] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [notificationSound, setNotificationSound] = useState(savedNotificationSound);


  const getNotificationSettingsHandler = async () => {
    setGetNotificationSettingsLoading(true);
    const token = await getAccessTokenSilently();
    UserService.getNotificationSettings({token})
      .then((response) => {
        setNotificationSettings(response?.notificationList);
        const selectedNotification = {};
        for (let notification of response?.notificationList) {
          selectedNotification[notification?.value] = {
            browser: notification?.active || notification?.activeBrowser,
            email: notification?.activeEmail
          }
        }
        setSelectedNotification(selectedNotification);
      })
      .catch((error) => {
        toastr.error("Error", error?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setGetNotificationSettingsLoading(false);
      });
  }

  const updateNotificationSettings = async () => {
    setIsLoading(true);
    const token = await getAccessTokenSilently();
    const notificationList = Object.keys(selectedNotification).reduce(
      (acc, key) => {
        acc.browser[key] = selectedNotification[key].browser;
        acc.email[key] = selectedNotification[key].email;
        return acc;
      },
      { browser: {}, email: {} }
    );
    const payload = {
      allowNotification: notificationList,
      notificationSound
    }
    UserService.updateNotificationSettings({token, body: payload})
      .then((response) => {
        localStorage.setItem("notificationSound", JSON.stringify(notificationSound));
        toastr.success("Success", "Notification settings updated successfully");
        onClose(true);
      })
      .catch((error) => {
        toastr.error("Error", error?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }



  useEffect(() => {
    getNotificationSettingsHandler();
  }, [])

  const onChangeHandler = (name, event, type) => {
    setSelectedNotification((prev) => {
      const newSelectedNotification = {...prev};
      if (type === "browser") {
        newSelectedNotification[name] = {
          ...newSelectedNotification[name],
          browser: event.target.checked
        }
      } else {
        newSelectedNotification[name] = {
          ...newSelectedNotification[name],
          email: event.target.checked
        }
      }
      return newSelectedNotification;
    });
  }


  const changeNotificationSound = (value) => {
    setNotificationSound(value);
  }


  return (
    <Box
      width="608px"
      textAlign="center"
      role="presentation"
      sx={{ padding: "35px 45px 28px 45px", fontFamily: fontConfig.LayoutNotificationSettingsTextFont.family }}
    >
      <NotificationSettingsCloseBtn
        className="text-left"
        style={{ fontSize: "16px", cursor: "pointer", fontFamily: fontConfig.LayoutNotificationSettingsCloseBtnFont.family }}
        onClick={() => onClose()}
      >
        <CloseIcon />
      </NotificationSettingsCloseBtn>

      <NotificationSettingsHeader className="update__user__header mt-3">
        <NotificationSettingsTitle>Notification settings</NotificationSettingsTitle>
        <div className="user__header__action">
          <button
            className="cancel_user_btn"
            onClick={() => onClose()}
            >
            Cancel
          </button>
          <button
            className="save_user_btn btn btn-primary"
            onClick={updateNotificationSettings}
            disabled={isLoading}
          >
            <span className="user_btn_text">Save</span>
            {isLoading && (
              <span className="ml-3 spinner spinner-white"></span>
            )}
          </button>
        </div>
      </NotificationSettingsHeader>
      <Divider
        sx={{ marginTop: "35px", marginBottom: "35px", color: "#002E5C" }}
      />
      <NotificationSettingsSwitch>
        <NotificationSettingsSwitchLabel>Notification sound</NotificationSettingsSwitchLabel>
        <FormControlLabel
          control={
            <Switch
              checked={notificationSound}
              onChange={(event) => {
                const { checked } = event.target;
                changeNotificationSound(checked);
              }}
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
          }
          style={{ margin: '0px' }}
        />
      </NotificationSettingsSwitch>
      <NotificationSettingsHead className="mt-3">
        <Typography
          variant="subtitle1"
          className=""
          sx={{ 
            color: "#9FA0A2",
            flex: 1,
           }}
          textAlign="left"
        >
          Select notifications type:
        </Typography>
        <NotificationSettingsHeadLabel>Browser</NotificationSettingsHeadLabel>
        <NotificationSettingsHeadLabel>Email</NotificationSettingsHeadLabel>
      </NotificationSettingsHead>
      <NotificationSettingsContent className="input_radio_field">
        {notificationSettings.length === 0 ? (
          getNotificationSettingsLoading ? (
            <div >
              <CircularProgress  />
            </div>
          ) : (
            <p>No notifications available.</p>
          )
        ) : (
          notificationSettings.map(({ _id, title, value, disable }, ndx) => {
            const isLast = notificationSettings.length - 1 === ndx;
            return (
              <NotificationSettingsContentItem key={_id}>
                <NotificationSettingsContentItemWrapper className="first_field">
                  <NotificationSettingsContentItemName
                    className={`role__field ${
                      disable ? "disable__module" : ""
                    }`}
                  >
                    {title}
                  </NotificationSettingsContentItemName>
                  <NotificationSettingsContentItemBox>
                    <Checkbox  
                      sx={{
                        padding: "0px",
                        '& .MuiSvgIcon-root': {
                          fontSize: 24,
                          fill: '#8e8e8e',
                        },
                        '&.Mui-checked .MuiSvgIcon-root': {
                          fill: '#2555EF',
                        },

                        '&.Mui-disabled .MuiSvgIcon-root': {
                          fill: '#8e8e8e',
                          opacity: 0.3,
                        },
                      }}
                      disabled={disable}
                      onChange={(event) => onChangeHandler(value, event, "browser")}
                      checked={selectedNotification[value]?.browser ? true : false}
                    />
                  </NotificationSettingsContentItemBox>
                  <NotificationSettingsContentItemBox>
                    <Checkbox  
                      sx={{
                        padding: "0px",
                        '& .MuiSvgIcon-root': {
                          fontSize: 24,
                          fill: '#8e8e8e',
                        },
                        '&.Mui-checked .MuiSvgIcon-root': {
                          fill: '#2555EF',
                        },

                        '&.Mui-disabled .MuiSvgIcon-root': {
                          fill: '#8e8e8e',
                          opacity: 0.3,
                        },
                      }}
                      disabled={disable}
                      onChange={(event) => onChangeHandler(value, event, "email")}
                      checked={selectedNotification[value]?.email ? true : false}
                    />
                  </NotificationSettingsContentItemBox>
                </NotificationSettingsContentItemWrapper>
                {!isLast && (
                  <Divider
                    sx={{
                      color: "#3F4255",
                      marginTop: "12px",
                      marginBottom: "12px",
                    }}
                  />
                )}
              </NotificationSettingsContentItem>
            );
          })
        )}
      </NotificationSettingsContent>
    </Box>
  )
}

export default NotificationSettings